import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').factory('TradeCondition', tradeConditionService);

    function tradeConditionService($resource, API_URL) {
        var URL = API_URL.SHIPPERS + '/tradingConditions';
        return $resource(URL + '/:id', { id: '@id' }, {});
    }
})();
